var styles = {"scaleInput":"styles_scale-input__PoHlH","scaleList":"styles_scale-list__NfS8c","scale":"styles_scale__-CFAB","disabled":"styles_disabled__FaGvK","innerCircle":"styles_inner-circle__F-y5e"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
